export enum AvailableLanguages {
    English = "en",
    Polish = "pl",
}
